import { Avatar, Divider, Button, Grid, List, ListItem, ListItemAvatar, ListItemText } from "@material-ui/core";
import { useFirestoreQuery } from "../../../firebase/hooks";
import { firestore } from "../../../helpers/firebaseHelper";

export default function LeadProduct(props) {
    const { livestream } = props;
    const livestreamsRef = firestore.collection('livestreams');
    const stream = useFirestoreQuery(
        livestreamsRef.where("id", "==", livestream)
    );

    return <Grid container className="mt-4">
        <Grid xs={12} sm={12}>
            <Grid container>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-whitesmoke1 text-sm font-medium text-black-60 p-2">
                    Full Name
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-whitesmoke1 text-sm font-medium text-black-60  p-2">
                    Item
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-whitesmoke1 text-sm font-medium text-black-60 p-2">
                    Qty
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-whitesmoke1 text-sm font-medium text-black-60 p-2">
                    Total
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-whitesmoke1 text-sm font-medium text-black-60 p-2">
                    Status
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-whitesmoke1 text-sm font-medium text-black-60 p-2">

                </Grid>
            </Grid>
        </Grid>
        <Grid xs={12} sm={12}>
            <Grid container>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-0">
                    <List disablePadding>
                        <ListItem disableGutters className="p-0">
                            <ListItemAvatar>
                                <Avatar>R</Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="Suresg" secondary="@testst" />
                        </ListItem>
                    </List>
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-0">
                    <List disablePadding>
                        <ListItem disableGutters className="p-0">
                            <ListItemAvatar>
                                <Avatar>R</Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="Suresg" secondary="@testst" />
                        </ListItem>
                    </List>
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    1x
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    MYR 120.12
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    Completed
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    <Button
                        className="text-black-60 "
                        variant="outlined"
                    >
                        View Details
                    </Button>
                </Grid>
            </Grid>
            <Divider />
            <Grid container>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-0">
                    <List disablePadding>
                        <ListItem disableGutters className="p-0">
                            <ListItemAvatar>
                                <Avatar>R</Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="Suresg" secondary="@testst" />
                        </ListItem>
                    </List>
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-0">
                    <List disablePadding>
                        <ListItem disableGutters className="p-0">
                            <ListItemAvatar>
                                <Avatar>R</Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="Suresg" secondary="@testst" />
                        </ListItem>
                    </List>
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    1x
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    MYR 120.12
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    Completed
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    <Button
                        className="text-black-60 "
                        variant="outlined"
                    >
                        View Details
                    </Button>
                </Grid>
            </Grid>
            <Divider /> <Grid container>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-0">
                    <List disablePadding>
                        <ListItem disableGutters className="p-0">
                            <ListItemAvatar>
                                <Avatar>R</Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="Suresg" secondary="@testst" />
                        </ListItem>
                    </List>
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-0">
                    <List disablePadding>
                        <ListItem disableGutters className="p-0">
                            <ListItemAvatar>
                                <Avatar>R</Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="Suresg" secondary="@testst" />
                        </ListItem>
                    </List>
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    1x
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    MYR 120.12
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    Completed
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    <Button
                        className="text-black-60 "
                        variant="outlined"
                    >
                        View Details
                    </Button>
                </Grid>
            </Grid>
            <Divider /> <Grid container>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-0">
                    <List disablePadding>
                        <ListItem disableGutters className="p-0">
                            <ListItemAvatar>
                                <Avatar>R</Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="Suresg" secondary="@testst" />
                        </ListItem>
                    </List>
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-0">
                    <List disablePadding>
                        <ListItem disableGutters className="p-0">
                            <ListItemAvatar>
                                <Avatar>R</Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="Suresg" secondary="@testst" />
                        </ListItem>
                    </List>
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    1x
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    MYR 120.12
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    Completed
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    <Button
                        className="text-black-60 "
                        variant="outlined"
                    >
                        View Details
                    </Button>
                </Grid>
            </Grid>
            <Divider /> <Grid container>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-0">
                    <List disablePadding>
                        <ListItem disableGutters className="p-0">
                            <ListItemAvatar>
                                <Avatar>R</Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="Suresg" secondary="@testst" />
                        </ListItem>
                    </List>
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-0">
                    <List disablePadding>
                        <ListItem disableGutters className="p-0">
                            <ListItemAvatar>
                                <Avatar>R</Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="Suresg" secondary="@testst" />
                        </ListItem>
                    </List>
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    1x
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    MYR 120.12
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    Completed
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    <Button
                        className="text-black-60 "
                        variant="outlined"
                    >
                        View Details
                    </Button>
                </Grid>
            </Grid>
            <Divider /> <Grid container>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-0">
                    <List disablePadding>
                        <ListItem disableGutters className="p-0">
                            <ListItemAvatar>
                                <Avatar>R</Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="Suresg" secondary="@testst" />
                        </ListItem>
                    </List>
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-0">
                    <List disablePadding>
                        <ListItem disableGutters className="p-0">
                            <ListItemAvatar>
                                <Avatar>R</Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="Suresg" secondary="@testst" />
                        </ListItem>
                    </List>
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    1x
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    MYR 120.12
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    Completed
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                    <Button
                        className="text-black-60 "
                        variant="outlined"
                    >
                        View Details
                    </Button>
                </Grid>
            </Grid>
            <Divider />
        </Grid>
    </Grid>
}